import { Button, Link, makeStyles, Typography } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import InsertLinkIcon from "@material-ui/icons/InsertLink";
import NewReleasesIcon from "@material-ui/icons/NewReleases";
import ShareIcon from "@material-ui/icons/Share";
import { get } from "lodash";
import React from "react";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
	rejected: {
		color: red[400],
	},
	supervisorNotes: {
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		maxWidth: 180,
		overflow: "hidden",
		color: red[300],
		cursor: "pointer",
	},
}));

const PromoteButton = ({
	record,
	data,
	id = get(record, "id", undefined),
	onRequestApprovalClick,
	cache,
	...props
}) => {
	if (!data) {
		data = {
			[record.id]: record,
		};
	}
	if (typeof cache === "object") {
		cache = get(cache, id, undefined);
	}
	const classes = useStyles();
	const translate = useTranslate();
	const approved =
		!get(data[id], "is_approval_required", false) ||
		get(data[id], "approval.status", "none") === "approved";
	const rejected = get(data[id], "approval.status", "none") === "rejected";
	const supervisorNotes = get(data[id], "approval.supervisor_notes");
	return (
		<React.Fragment>
			{get(data[id], "status") === "active" ? (
				approved ? (
					<Button
						startIcon={<InsertLinkIcon />}
						color="primary"
						component={Link}
						href={`#/channels?filter=${JSON.stringify({
							bookmaker_id: get(data[id], "id"),
						})}`}
					>
						{translate("resources.deals.actions.promote_link")}
					</Button>
				) : (
					(!cache && (
						<>
							<Button
								startIcon={
									rejected && supervisorNotes ? (
										<NewReleasesIcon />
									) : (
										<ShareIcon />
									)
								}
								color="primary"
								className={rejected ? classes.rejected : ""}
								onClick={onRequestApprovalClick.bind(this, data[id])}
							>
								{translate(
									`resources.deals.actions.promote_${get(
										data[id],
										"approval.status",
										"none"
									)}`
								)}
							</Button>
							{supervisorNotes && rejected && (
								<Typography
									onClick={onRequestApprovalClick.bind(this, data[id])}
									variant="caption"
									component="p"
									className={classes.supervisorNotes}
								>
									{supervisorNotes}
								</Typography>
							)}
						</>
					)) || (
						<Button disabled>
							{translate("resources.deals.messages.promote_waiting_approval")}
						</Button>
					)
				)
			) : (
				<Button disabled>
					{translate("resources.deals.messages.bookmaker_paused")}
				</Button>
			)}
		</React.Fragment>
	);
};

export default PromoteButton;
